import { CareOrderBabyForTransferInstructionPage } from './CareOrderBabyForTransferInstructionPage';
export class CareOrderBabyUConverter {
    static getDataForTransferInstructionPage({ careOrderBaby, }) {
        const careOrderBabyForTransferInstructionPage = new CareOrderBabyForTransferInstructionPage({
            careOrderBaby,
        });
        return careOrderBabyForTransferInstructionPage;
    }
}
